import React from "react";
import ContentWrapper from "../common/ContentWrapper";
import TournamentFetcher from "./TournamentFetcher";
import Tournament from "./Tournament";
import { usePrematchData } from "./PrematchDataFetcher";
import { iconSportCssClass } from "../data/utils";
import SportHeader from "../common/SportHeader";
import { useParams } from "../router/Router";
import ErrorMessage from "../common/ErrorMessage";
import { getLabel } from "../InitData";

export default function Category() {
    const p = useParams();
    const prematchData = usePrematchData();
    
    try {
        const sport = prematchData.sportById[p.sportId];
        const sportIcon = iconSportCssClass(sport.sportRef, sport.iconClass);
        const category = sport.categoryById[p.categoryId];
    
        return (
            <ContentWrapper columns="1">
                <SportHeader icon={sportIcon} desc={sport.descrizione} />
                {category.tournaments.map(tournament =>
                    <TournamentFetcher key={tournament.uniqueId} data={tournament} renderItem={(data) =>
                        <Tournament data={data} />
                    } />
                )}
            </ContentWrapper>
        );
    } catch (e) {
        return <ErrorMessage text={getLabel('general.error')} />
    }
}
